/* import AsyncStorage from '@react-native-community/async-storage'; */


export const StorageService = {

  setItem: async (key, value) => {
    return localStorage.setItem(key, value)
  },
  getItem: async (key) => {
    return localStorage.getItem(key)
  },
  removeItem: async (key) => {
    localStorage.removeItem(key)
  },
  clear: async () => {
    localStorage.clear()
  }

};